/* global fetch, FormData */
import "babel-polyfill";
import "es6-promise/auto";
import "whatwg-fetch";
import React from "react";
import Helmet from "react-helmet";
import cx from "classnames";
import Icon from "../components/Icon";
import Footer from "../components/Footer";
import browserOptimize from "../utils/browserOptimize";
import Recaptcha from "react-google-recaptcha";

class ContactUs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.verify = this.verify.bind(this);
    this.state = {
      message: null,
      errors: {},
      responseType: null
    };
  }

  verify(e) {
    e.preventDefault();
    this.recaptcha.execute();
  }

  handleSubmit() {
    const form = new FormData(this.form);

    this.setState(state => ({
      ...state,
      errors: {}
    }));

    const formEntries = browserOptimize(form, this.form);

    let valid = true;
    const errors = {};
    formEntries.forEach(([key, value]) => {
      if (key !== "bot-field") {
        if (!value.trim().length || value === "1") {
          errors[key] = true;
          valid = false;
        }
        if (key === "email") {
          const regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          const test = regEx.test(value);
          if (!test) {
            errors[key] = true;
            valid = false;
          }
        }
      }
    });

    if (!valid) {
      this.recaptcha.reset();
      this.setState(state => ({
        ...state,
        errors,
        message: "Please fill out all required fields."
      }));
      return;
    }

    // Form needs to go to a working endpoint
    fetch(this.form.getAttribute("action"), {
      method: "POST",
      body: form
    }).then(response => {
      if (response.status >= 400) {
        this.setState(() => ({
          message: "There was a problem with your submission.",
          responseType: "error"
        }));
      }
      this.setState(() => ({
        message: "Thank you for contacting us! We will be in touch soon.",
        responseType: "success"
      }));
      this.form.reset();
      this.recaptcha.reset();
    });
  }

  render() {
    const { message, errors, responseType } = this.state;

    return (
      <div className="flex flex-column items-center">
        <Helmet>
          <title>Gulf Seaboard – Contact Us</title>
        </Helmet>
        <div className="w-80">
          <h1 className="f-l f-xxl-l red-dark ma0 fw3 lh-s pb2 pb4-l pt5 pt6-l">
            Contact Us
          </h1>
        </div>
        <div
          className="w-100 h2 flex flex-column items-center justify-center tc-m ph2 relative"
          style={{
            backgroundImage: `url("https://s3.amazonaws.com/mobelux-morty/uploads/gulf-seaboard/contact/dsc_2521.jpg")`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center"
          }}
        >
          <div
            className="absolute top-0 left-0 w-100 h-100"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.3)"
            }}
          />
          <div className="pb3 pb4-l z-0">
            <Icon name="white-flag-icon" />
          </div>
          <h2 className="f-r f-m-l white ma0 fw3 flex flex-column lh-l w-40-l z-0">
            Have a project you’d like to work together on or just a general
            question? Get in touch!
          </h2>
        </div>

        <div className="w-80 pt5-l flex flex-column flex-row-l">
          <div className="flex flex-column w-40-l">
            <div className="pt3 pt0-l pb3-l">
              <p className="f-xs ls-s ttu b red-dark ma0 pb1">Address</p>
              <p className="f-s f-r-l fw3 ma0 pt1">
                629 North Washington Highway
              </p>
              <p className="f-s f-r-l fw3 ma0 pt1">Post Office Box 1688</p>
              <p className="f-s f-r-l fw3 ma0 pt1">Ashland, Virginia 23005</p>
            </div>
            <div className="pb3-l pt3">
              <p className="f-xs ls-s ttu b red-dark ma0 pb1">Email</p>
              <a href="mailto:info@gulfseaboard.com">
                <p className="f-s f-r-l fw3 ma0 pt1">info@gulfseaboard.com</p>
              </a>
            </div>
            <div className="pb4 pt3">
              <p className="f-xs ls-s ttu b red-dark ma0 pb1">Phone</p>
              <p className="f-s f-r-l fw3 ma0 pt1 dn-ns">804.752.7600</p>
              <a className="dn-m" href="tel:+8047527600">
                <p className="f-s f-r-l fw3 ma0 pt1">804.752.7600</p>
              </a>
            </div>
          </div>
          <div className="w-60-l">
            <form
              data-netlify
              data-netlify-honeypot="bot-field"
              data-netlify-recaptcha
              method="POST"
              action="/"
              id="contact-form"
              name="contact"
              className="flex flex-column"
              ref={f => {
                this.form = f;
              }}
              onSubmit={this.verify}
            >
              <input type="hidden" name="form-name" value="contact" />
              <span className="dn">
                <input name="bot-field" />
              </span>
              <input
                placeholder="Name"
                aria-labelledby="Name"
                name="name"
                className={cx(
                  "mb2 mb2 br2 ba b--black-30 b ttu f-xxs f-xs-m ls-s black-50 pa1",
                  { "b--red-error": errors.name }
                )}
              />
              <input
                placeholder="Email"
                aria-labelledby="Email"
                name="email"
                className={cx(
                  "mt1 mb2 br2 ba b--black-30 b ttu f-xxs f-xs-m ls-s black-50 pa1",
                  { "b--red-error": errors.email }
                )}
              />
              <input
                placeholder="Company"
                aria-labelledby="Company"
                name="company"
                className={cx(
                  "mt1 mb2 br2 ba b--black-30 b ttu f-xxs f-xs-m ls-s black-50 pa1",
                  { "b--red-error": errors.company }
                )}
              />
              <input
                placeholder="Subject"
                aria-labelledby="Subject"
                name="subject"
                className={cx(
                  "mt1 mb2 br2 ba b--black-30 b ttu f-xxs f-xs-m ls-s black-50 pa1",
                  { "b--red-error": errors.subject }
                )}
              />
              <textarea
                placeholder="Message"
                aria-labelledby="Message"
                name="message"
                className={cx(
                  "mt1 mb2 h1 br2 ba b--black-30 b ttu f-xxs f-xs-m ls-s black-50 pa1 input-reset",
                  { "b--red-error": errors.message }
                )}
              />
              <div>
                <Recaptcha
                  ref={e => {
                    this.recaptcha = e;
                  }}
                  sitekey="6LfP1VcUAAAAAC_hGC5qSWnD1db4NMKogKkK1fvL"
                  onChange={this.handleSubmit}
                  size="invisible"
                />
              </div>
              <button
                className="mt1 b--red-dark b--solid bg-red-dark bg-red-dark-70-hover b--transparent-hover br1 bw3 pa0 pointer bg-animate"
                aria-label="Submit Message"
              >
                <a className="f-xxs f-xs-m ttu b white pv1 db ls-s">
                  Submit Message
                </a>
              </button>
              {message && (
                <div
                  className={cx("pv2 fw3 tc", {
                    "red-error":
                      errors.name ||
                      errors.email ||
                      errors.subject ||
                      errors.company ||
                      errors.message
                  })}
                >
                  {" "}
                  {message}{" "}
                </div>
              )}
            </form>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/pages/contact-us.js